import { styled, TextField } from '@mui/material';

import { styledCustom } from '/styles';

export const EllipsisTextField = styled(TextField)({
  '& .MuiInputBase-input': {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

export const FormContainer = styledCustom('div')<{ $hasCustom?: boolean }>`
  display: grid;
  gap: ${({ theme }) => theme.spacing(1)};
  grid-template-columns: ${({ $hasCustom }) => ($hasCustom ? '1fr 1fr 1fr' : '1fr 1fr')};
`;
